import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { AutoSuggestionItem } from '../../features/autocomplete/autocompleteSlice';

const autocompleteService = {
  getAutoSuggestions: async (
    prefix: string,
    locale: string,
  ): Promise<AutoSuggestionItem[]> => {
    prefix = prefix.trim();
    if (!prefix) {
      return [];
    }

    const params = { prefix, locale };

    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params,
    };

    const response = await axios.get<AutoSuggestionItem[]>(
      `/search-api/getautosuggestions`,
      config,
    );
    return response.data;
  },
};

export default autocompleteService;
